import React from 'react';
import { QuestRoute } from '../../../api/QuestRoutes';
import { generateId, statusColors } from '../../../utility/functions';
import Dot from '../../../Dot';
import Table from '../../../table/Table';
import LinkTo from '../../../forms/LinkTo';
import Row from '../../../layout/Row';


const AppReferral = ({ ...props }) => {

    const tableConfig = {
        endpoint: QuestRoute.reports.mobile.appReferral,
        isReport: true,
        searchLimit: 365,
        headers: [
            {
                label: 'Name',
                propKey: 'name',
            }, {
                label: 'Email',
                propKey: 'email',
            }, {
                label: 'Referral Sign-Ups',
                propKey: 'referralSignupCount',
            }, {
                label: 'LoyaltyPoints Earned',
                propKey: 'loyaltyPointsEarned',
            },
        ],
        sticker: [
            {
                label: 'Top Referrer',
                color: '#004280',
                callback: (data) => {
                    if (!data.length) return '-';
                    const index = data.reduce((highestIndex, currentElement, currentIndex, array) => {
                        return currentElement.referralSignupCount > array[highestIndex].referralSignupCount ? currentIndex : highestIndex;
                    }, 0)
                    return `${data[index].name}: (${data[index].referralSignupCount})`
                }
            },
            {
                label: 'Loyalty Points Given',
                color: '#5377c9',
                callback: (data) => data.reduce((a, b) => b.loyaltyPointsEarned + a, 0)
            },
            {
                label: 'Referral Purchases',
                color: '#dc3545',
                callback: (data) => data.reduce((a, b) => b.referralSignups.reduce((c, d) => (d.firstPurchaseDate ? 1 : 0) + c, 0) + a, 0)
            },
            {
                label: 'Referral Sign-Ups',
                color: '#e68800',
                callback: (data) => data.reduce((a, b) => b.referralSignupCount + a, 0)
            },
        ],
        renderFormat: (e) => ({
            row: (
                <tr key={generateId()}>
                    <td>
                        <LinkTo
                            target='_blank'
                            customerId={e.userId}
                        >
                            {e.name}
                        </LinkTo>
                    </td>
                    <td>{e.email}</td>
                    <td>{e.referralSignupCount}</td>
                    <td>{e.loyaltyPointsEarned}</td>
                </tr>
            ),
            toggleIndex: 2,
            children: (
                <Table
                    config={{
                        compact: true,
                        disableTableControls: true,
                        disableHeaderSearch: true,
                        data: e.referralSignups,
                        colSpacing: [40, 60],
                        headers: [
                            {
                                label: 'Name',
                                propKey: 'name',
                            }, {
                                label: 'Email',
                                propKey: 'email',
                            },
                        ],
                        renderFormat: (f) => (
                            <tr key={generateId()}>
                                <td>
                                    <Row>
                                        <Dot color={statusColors[f.status]} />
                                        <LinkTo
                                            target='_blank'
                                            customerId={f.userId}
                                        >
                                            {f.name}
                                        </LinkTo>
                                    </Row>
                                </td>
                                <td>{f.email}</td>
                            </tr>
                        )
                    }}
                />
            )
        })
    }

    return (
        <Table config={tableConfig} />
    );
}

export default AppReferral;